import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class EmployerMembership extends ApplicationRecord {
  static jsonapiType = "employer_memberships";

  @Attr() createdAt: string;

  @Attr() credits: number;

  @Attr() employerId: number;

  @Attr() plan: string;

  @Attr() price: number;
}

export default EmployerMembership;
